import { initialState } from '@/store/modules/domains/domains'

export default {
  QUEUE_DOMAIN (state, domain_id) {
    if (state.domainQueue.indexOf(domain_id) === -1) {
      state.domainQueue.push(domain_id)
    }
  },
  UNQUEUE_DOMAIN (state, domain_id) {
    state.domainQueue = state.domainQueue.filter(x => {
      if (x !== domain_id) {
        return x
      }
    })
  },
  CLEAR_DOMAIN_QUEUE (state) {
    state.domainQueue = []
  },
  SET_CURRENT_DOMAIN (state, domain_id) {
    state.domain_id = domain_id
  },
  POPULATE_DOMAIN (state, domain) {
    if (domain && domain.id) {
      // remove duplicates if existing
      state.domainCache = state.domainCache.filter(x => { // remove duplicates if existing
        if (x.id !== domain.id) {
          return x
        }
      })
      state.domainCache.push(domain)
      state.domainQueue = state.domainQueue.filter(x => {
        if (x !== domain.id) {
          return x
        }
      })
    }
  },
  CLEAR_DOMAINS_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_DOMAINS_TRANSFER_LIST (state, domainsTransferList) {
    state.domainsTransferList = domainsTransferList
  },
  SET_DOMAIN_CHANGE_REQUESTS (state, domainChangeRequests) {
    state.domainChangeRequests = domainChangeRequests
  },
  SET_DOMAIN_CHANGE_INTERVAL (state, domainChangeInterval) {
    state.domainChangeInterval = domainChangeInterval
  },
}
